import React from 'react';
import styled from 'styled-components';

import mdToHtml from '../../util/mdToHtml';

import Top from '../top';

const StyledContent = styled.section`
	text-align: left;
	h1 {
		font-size: 2.5rem;
		line-height: 3rem;
		margin-bottom: 1rem;
	}

	h2 {
		font-family: ${(p) => p.theme.fonts.body};
		color: ${(p) => p.theme.color.red};
		line-height: 1;
		text-transform: uppercase;
		font-size: 1rem;
		margin-bottom: 1.4em;
	}

	.columns {
		display: flex;
		flex-direction: row;
		align-items: stretch;
		justify-content: stretch;
		flex-wrap: wrap;

		.column {
			width: 50%;
			padding: 4rem 0;
			display: flex;
			flex-direction: column;

			@media (max-width: 768px) {
				width: 100%;
			}

			&.light-bg {
				background-color: ${(p) => p.theme.color.light};
			}

			&:first-child {
				align-items: flex-end;

				@media (max-width: 768px) {
					align-items: flex-start;
				}

				ul {
					list-style: disc;
					padding-left: 1em;
				}
			}

			&:nth-child(2) {
				align-items: flex-start;
			}

			.column-inner {
				max-width: 600px;
				padding: 0 4rem 0 3rem;

				@media (max-width: 768px) {
					padding: 0 2.5rem 0 2.5rem;
				}

				@media (max-width: 500px) {
					padding: 0 1rem 0 1rem;
				}

				.more {
					list-style-type: none;

					li {
						margin-bottom: 1em;
						margin-left: 1.3rem;
						position: relative;

						&::before {
							content: '•';
							font-size: 1.9rem;
							color: ${(p) => p.theme.color.red};
							position: absolute;
							left: -1.3rem;
							top: -8px;
						}
					}
				}
			}
		}
	}
`;

export default ({ title, copy, more }) => {
	return (
		<StyledContent>
			<div className="columns">
				<div className="column">
					<div className="column-inner">
						<Top color="green">LESSONS WITH ARCADIA</Top>
						<h1>{title}</h1>
						<div
							className="md-content"
							dangerouslySetInnerHTML={{
								__html: mdToHtml(copy),
							}}
						/>
					</div>
				</div>
				<div className="column light-bg">
					<div className="column-inner">
						<h2>OUR PROGRAMS ALSO PROVIDE STUDENTS THE OPPORTUNITY TO:</h2>
						{more ? (
							<ul className="more">
								{more.map((item, i) => (
									<li key={`${item}-${i}`}>{item}</li>
								))}
							</ul>
						) : (
							<p>Sorry. Nothing to see here &hellip; yet.</p>
						)}
					</div>
				</div>
			</div>
		</StyledContent>
	);
};
